import Axios from "axios";
import { ApiBaseUrl, DashboardBaseUrl, SupplierNoticeBaseUrl } from "../config/config";
import { ApiResultModel } from "../models/common.model";
import { UserDashboardItemsRequest,DashboardRequest, DashboardResponse, IdRequest, DashboardItems, CloneDashboardRequest, UpdateUserDashboardsRequest as UpdateUserDashboardsConfigRequest, DashboardIdResponse } from "../models/dashboard.model";



export const GetUserDashboards = (): Promise<DashboardRequest[]> => {
    return Axios.get<ApiResultModel<DashboardRequest[]>>(
      ApiBaseUrl + DashboardBaseUrl + "/GetUserDashboards"
    ).then((result) => {
      return result.data.data;
    });
  };


  export const UserDashboardItems = (request: IdRequest): Promise<DashboardItems[]> => {
    return Axios.post<ApiResultModel<DashboardItems[]>>(
      ApiBaseUrl + DashboardBaseUrl + "/UserDashboardItems",request
    ).then((result) => {
      return result.data.data;
    });
  };


  export const SetFavoriteReport = (request: IdRequest): Promise<ApiResultModel<boolean>> => {
    return Axios.post<ApiResultModel<boolean>>(
      ApiBaseUrl + DashboardBaseUrl + "/SetFavoriteReport",request
    ).then((result) => {
      return result.data;
    });
  };

  export const CreateUserDashboard = (request: UserDashboardItemsRequest): Promise<DashboardIdResponse> => {
    return Axios.post<ApiResultModel<DashboardIdResponse>>(
      ApiBaseUrl + DashboardBaseUrl + "/CreateUserDashboard",request
    ).then((result) => {
      return result.data.data;
    });
  };

  export const CloneUserDashboard = (request: CloneDashboardRequest): Promise<ApiResultModel<DashboardIdResponse>> => {
    return Axios.post<ApiResultModel<DashboardIdResponse>>(
      ApiBaseUrl + DashboardBaseUrl + "/CloneUserDashboard",request
    ).then((result) => {
      return result.data;
    });
  };


  export const UpdateUserDashboard = (request: UserDashboardItemsRequest): Promise<boolean> => {
    return Axios.post<ApiResultModel<boolean>>(
      ApiBaseUrl + DashboardBaseUrl + "/UpdateUserDashboard",request
    ).then((result) => {
      return result.data.data;
    });
  };

  export const UpdateUserDashboardsConfig = (request: UpdateUserDashboardsConfigRequest): Promise<ApiResultModel<boolean>> => {
    return Axios.post<ApiResultModel<boolean>>(
      ApiBaseUrl + DashboardBaseUrl + "/UpdateUserDashboardsConfig",request
    ).then((result) => {
      return result.data;
    });
  };

  export const DeleteUserDashboard = (request: IdRequest): Promise<ApiResultModel<boolean>> => {
    return Axios.post<ApiResultModel<boolean>>(
      ApiBaseUrl + DashboardBaseUrl + "/DeleteUserDashboard",request
    ).then((result) => {
      return result.data;
    });
  };